@if (!hasPermission) {
  <div class="flex items-center justify-center gap-2 rounded-lg border border-red-200 bg-red-50 p-6 text-sm font-semibold text-red-700">
    <mat-icon class="!text-base text-red-400">lock</mat-icon>
    Permissions Restricted
  </div>
} @else {
  <!-- Header -->
  <div class="mb-3 flex items-center gap-2">
    <mat-icon class="!text-base text-violet-600">directions_walk</mat-icon>
    <h2 class="text-secondary text-sm font-semibold uppercase tracking-wide">Visitor Activity (24h)</h2>
  </div>

  <!-- Loading skeleton -->
  @if (loading) {
    <div class="space-y-2">
      @for (_ of [1, 2, 3, 4]; track $index) {
        <div class="h-9 animate-pulse rounded-lg bg-gray-100"></div>
      }
    </div>
  }

  <!-- Error state -->
  @else if (error) {
    <div class="flex items-center gap-2 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600">
      <mat-icon class="!text-base">error_outline</mat-icon>
      <span>{{ error }}</span>
    </div>
  }

  <!-- Empty state -->
  @else if (!data || data.communities.length === 0) {
    <div class="flex flex-col items-center gap-1.5 rounded-lg border border-dashed border-gray-200 py-8 text-center">
      <mat-icon class="!text-3xl text-gray-300">no_meeting_room</mat-icon>
      <span class="text-xs text-gray-400">No VMS-enabled communities found</span>
    </div>
  } @else {
    <!-- Mini KPI tiles -->
    <div class="mb-3 grid grid-cols-2 gap-2">
      <div class="rounded-lg border border-indigo-100 bg-indigo-50 p-3 text-center">
        <div class="text-[10px] uppercase tracking-wide text-gray-500">Visitors (24h)</div>
        <div class="mt-0.5 text-lg font-bold text-indigo-700">{{ data.total_visitors_24h }}</div>
      </div>
      <div class="rounded-lg border border-purple-100 bg-purple-50 p-3 text-center">
        <div class="text-[10px] uppercase tracking-wide text-gray-500">VMS Enabled</div>
        <div class="mt-0.5 text-lg font-bold text-purple-700">{{ data.enabled_communities }}</div>
      </div>
    </div>

    <!-- Community list — only shown when there is at least one visitor -->
    @if (data.total_visitors_24h > 0) {
      <div class="divide-y divide-gray-50">
        @for (community of data.communities.slice(0, 5); track community.id) {
          <div class="flex items-center gap-2.5 py-2 transition-colors hover:bg-gray-50">
            <div class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-purple-50">
              <mat-icon class="!text-sm text-purple-600">location_city</mat-icon>
            </div>
            <span class="min-w-0 flex-1 truncate text-xs font-medium text-gray-700" [matTooltip]="community.name">{{ community.name }}</span>
            <span class="shrink-0 rounded-full px-2 py-0.5 text-[10px] font-bold leading-none" [ngClass]="getVisitorBadgeClass(community.visitors_24h)">
              {{ community.visitors_24h }}
            </span>
          </div>
        }
      </div>
    }
  }
}
